import { api, APIResponse } from '@/store/api';
import type { GetUsersParams, GetUsersResponse } from '@/types/users.types';

export const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<GetUsersResponse, GetUsersParams>({
      query: (params = {}) => {
        const searchParams = new URLSearchParams();
        if (params.page) searchParams.append('page', params.page.toString());
        if (params.limit) searchParams.append('limit', params.limit.toString());
        if (params.text) searchParams.append('text', params.text);
        return {
          url: `admin/users?${searchParams.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response: APIResponse<GetUsersResponse>) => response.data,
      providesTags: ['Users'],
    }),
  }),
});

export const { useGetUsersQuery } = usersApi; 